import script from "./QActsFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./QActsFilters.vue?vue&type=script&setup=true&lang=js"

import "./QActsFilters.vue?vue&type=style&index=0&id=0ca94ade&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ca94ade"]])

export default __exports__